import React, { useState, useEffect } from "react";
import AccountProfile from "components/AccountProfile";
import MyVoucher from "../../services/MyVoucher";
import ChangePassword from "../../services/ChangePassword";
import MissingPoint from "../../services/MissingPoint";
import RewardsHistory from "../../services/RewardsHistory";
import AccountFeedback from "../../services/FeedBack";
import PastFutureReservation from "../../services/PastFutureReservation";

const AccountTab = ({ ...props }) => {
  useEffect(() => {
    setActiveKey();
  }, [props.location.hash]);

  // Fallback: check window.location.hash on mount (covers redirect from callback)
  useEffect(() => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      if (hash === "#points-history") setActiveTab("pointHistory");
      if (hash === "#my_voucher") setActiveTab("myVouchers");
      if (hash === "#feedback") setActiveTab("feedback");
      if (hash === "#personal_info") setActiveTab("personalInfo");
    }
  }, []);

  const setActiveKey = () => {
    const hash =
      props.location.hash ||
      (typeof window !== "undefined" ? window.location.hash : "");
    if (!hash) return;
    if (hash === "#feedback") {
      setActiveTab("feedback");
    }
    if (hash === "#my_voucher") {
      setActiveTab("myVouchers");
    }
    if (hash === "#personal_info") {
      setActiveTab("personalInfo");
    }
    if (hash === "#points-history") {
      setActiveTab("pointHistory");
    }
  };

  const isAuth0Enabled = process.env.GATSBY_ENABLE_AUTH0 === "true";

  const [activeTab, setActiveTab] = useState("myReservation");
  const [reservationFilter, setReservationFilter] = useState("all");

  const handleTabChange = (newValue) => {
    if (props.location.hash) {
      props.location.hash = "";
      window.history.pushState(
        "",
        "",
        props.location.origin + props.location.pathname
      );
    }
    setActiveTab(newValue);
  };

  const getTabStyle = (tabName) => ({
    borderBottom: activeTab === tabName ? "2px solid #37B0E5" : "none",
    color: activeTab === tabName ? "#37B0E5" : "#ACBFC6",
    fontWeight: activeTab === tabName ? "400" : "350",
  });

  return (
    <>
      <div className="tw-w-full tw-p-4 md:tw-p-0 tw-overflow-hidden tw-mt-6 sm:tw-mt-2">
        <div className="tw-w-full tw-flex tw-justify-between tw-overflow-scroll tw-overflow-y-hidden md:tw-overflow-hidden tw-gap-4 tw-scrollbar-hidden">
          <button
            style={getTabStyle("myReservation")}
            className="tw-pb-2 tw-bg-transparent tw-text-[14px] sm:tw-text-[16px] tw-leading-4 sm:tw-leading-[20px] tw-font-gotham tw-whitespace-nowrap"
            onClick={() => handleTabChange("myReservation")}>
            {props.langData.menu_tab_my_reservation}
          </button>
          <button
            style={getTabStyle("myVouchers")}
            className="tw-pb-2 tw-bg-transparent tw-text-[14px] sm:tw-text-[16px] tw-leading-4 sm:tw-leading-[20px] tw-font-gotham tw-whitespace-nowrap"
            onClick={() => handleTabChange("myVouchers")}>
            {props.langData.menu_tab_my_voucher}
          </button>
          <button
            style={getTabStyle("pointHistory")}
            className="tw-pb-2 tw-bg-transparent tw-text-[14px] sm:tw-text-[16px] tw-leading-4 sm:tw-leading-[20px] tw-font-gotham tw-whitespace-nowrap"
            onClick={() => handleTabChange("pointHistory")}>
            {props.langData.menu_tab_transaction_history}
          </button>
          <button
            style={getTabStyle("feedback")}
            className="tw-pb-2 tw-bg-transparent tw-text-[14px] sm:tw-text-[16px] tw-leading-4 sm:tw-leading-[20px] tw-font-gotham tw-whitespace-nowrap"
            onClick={() => handleTabChange("feedback")}>
            {props.langData.menu_tab_feedback}
          </button>
          <button
            style={getTabStyle("missingPoint")}
            className="tw-pb-2 tw-bg-transparent tw-text-[14px] sm:tw-text-[16px] tw-leading-4 sm:tw-leading-[20px] tw-font-gotham tw-whitespace-nowrap"
            onClick={() => handleTabChange("missingPoint")}>
            {props.langData.menu_tab_missing_point}
          </button>
          <button
            style={getTabStyle("personalInfo")}
            className="tw-pb-2 tw-bg-transparent tw-text-[14px] sm:tw-text-[16px] tw-leading-4 sm:tw-leading-[20px] tw-font-gotham tw-whitespace-nowrap"
            onClick={() => handleTabChange("personalInfo")}>
            {props.langData.menu_tab_profile}
          </button>
        </div>

        <div className="tw-mt-6">
          {activeTab === "myReservation" && (
            <PastFutureReservation
              langData={props.MyReservationlang}
              openWidgetAction={props.openWidgetAction}
            />
          )}
          {activeTab === "myVouchers" && (
            <div className="tw-mb-0 sm:tw-mb-4">
              <MyVoucher
                langData={props.MyVoucherlang}
                openWidgetAction={props.openWidgetAction}
                locale={props.language}
              />
            </div>
          )}
          {activeTab === "pointHistory" && (
            <RewardsHistory
              langData={props.TransactionHistorylang}
              openWidgetAction={props.openWidgetAction}
            />
          )}
          {activeTab === "feedback" && (
            <AccountFeedback langData={props.FeedbackLang} />
          )}
          {activeTab === "missingPoint" && (
            <MissingPoint
              langData={props.MissingPointLang}
              guestId={props.guestId}
            />
          )}
          {activeTab === "personalInfo" && (
            <AccountProfile
              editProfileUrl={props.editProfileUrl}
              langData={props.MemberProfilelang}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default AccountTab;
